

















import {
  defineComponent,
} from '@nuxtjs/composition-api';
import PictureItem from "~/components/Palmers/BaseComponents/Picture/PictureItem.vue";
import {useUrl} from "~/composables/Palmers";

export default defineComponent({
  name: 'CategoryGridItemMobile',
  components: {
    PictureItem
  },
  props: {
    category: {
      type: Object,
      require: true
    }
  },
  setup(props) {
    const {getPageUrl} = useUrl();

    const categoryUrl = props.category.url_path + props.category.url_suffix;

    return {
      categoryUrl,
      getPageUrl
    }
  }
});
